"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _onEnterPressed = _interopRequireDefault(require("../../../common/utils/onEnterPressed")),
    _drawerHandler = require("../styles/drawerHandler"),
    ICON_MAP = function ICON_MAP(a) {
  var b = a.isVertical,
      c = a.isMinimised;
  return b ? c ? "arrowleft" : "arrowright" : c ? "arrowdown" : "arrowup";
},
    DrawerHandler = function DrawerHandler(a) {
  var b = a.visibilityHandler,
      c = a.isVertical,
      d = a.isMinimised;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(c ? _drawerHandler.V_NAV_HANDLER : _drawerHandler.H_NAV_HANDLER, "drawer__tab"),
    onClick: b,
    onKeyDown: (0, _onEnterPressed["default"])({
      onClick: b
    }),
    role: "presentation"
  }, _react["default"].createElement(_Icon["default"], {
    name: ICON_MAP({
      isVertical: c,
      isMinimised: d
    }),
    color: "white",
    size: 10,
    className: (0, _classnames["default"])(c ? _drawerHandler.V_HANDLER_ARROW : _drawerHandler.H_HANDLER_ARROW)
  }));
},
    _default = DrawerHandler;

exports["default"] = _default;